// Auto-generated skeleton for Image

export const Image: Api.Image = {
  id: 0,
  file_hash_name: null,
  file_original_name: null,
  file_size: 0,
  file_checksum_md5: null,
  file_checksum_sha1: null,
  created: null,
  updated: null,
};

